/**
 * Currency utility functions for GBP formatting
 */

export const formatGBP = (amount: number): string => {
  if (isNaN(amount) || amount === null || amount === undefined) {
    return '£0.00';
  }
  
  return new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
};

export const formatGBPShort = (amount: number): string => {
  if (isNaN(amount) || amount === null || amount === undefined) {
    return '£0';
  }
  
  // For whole numbers, show without decimals
  if (amount % 1 === 0) {
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);
  }
  
  return new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
};

export const calculateAverage = (items: any[], field: string): number => {
  if (!items || items.length === 0) {
    return 0;
  }
  
  const validItems = items.filter(item => 
    item[field] !== null && 
    item[field] !== undefined && 
    !isNaN(Number(item[field])) &&
    Number(item[field]) >= 0
  );
  
  if (validItems.length === 0) {
    return 0;
  }
  
  const sum = validItems.reduce((total, item) => total + Number(item[field]), 0);
  return sum / validItems.length;
};
